import React, { useEffect, useState } from 'react';

// Role-independent, read-only coarse feedback. No candidate details or action
// capability: startup recovery remains owned by Electron and its journals.
export default function DesktopPortableRecoveryNotice() {
  const bridge = window.lvbDesktop;
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let disposed = false;
    let revision = -1;
    if (typeof bridge?.getPortableRecoveryStatus !== 'function') return undefined;
    const accept = (value) => {
      if (disposed || !Number.isSafeInteger(value?.revision) || value.revision < revision) return;
      revision = value.revision;
      setStatus({ state: value.state, cacheWorkHeld: value.cacheWorkHeld === true });
    };
    const unsubscribe = bridge.onPortableRecoveryStatusChanged?.(accept);
    Promise.resolve().then(() => bridge.getPortableRecoveryStatus()).then(accept).catch(() => {
      if (!disposed && revision === -1) setStatus({ state: 'unavailable' });
    });
    return () => { disposed = true; unsubscribe?.(); };
  }, [bridge]);
  if (!bridge?.getPortableRecoveryStatus || status?.state === 'ready') return null;
  const pending = status?.state === 'recovery-pending';
  return (
    <div role="status" aria-live="polite" className="border-b bg-amber-50 px-4 py-3 text-sm">
      <p>{pending ? 'The app is checking an unresolved downloaded-data operation.'
        : status?.state === 'unavailable' ? 'Portable cache recovery status is unavailable.'
          : 'Checking portable cache recovery…'}</p>
      {(pending || status?.cacheWorkHeld) && <p>Some offline features may be temporarily unavailable. Keep the app open. This notice does not establish whether data was replaced. An administrator can save a diagnostic report in Settings → Portable Transfer → Receive. Do not start another replacement or delete app data.</p>}
    </div>
  );
}
